import {
  Accordion,
  AccordionDetails,
  Divider,
  Typography,
} from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

export const StyledAlreadyAnsweredNotice = styled('div')(() => ({
  padding: '32px 0 24px',
  textAlign: 'center' as const,
}));

export const StyledDivider = styled(Divider)(() => ({
  marginBottom: 8,
}));

/** Outer accordion — "Visualiser mes réponses précédentes" */
export const StyledOuterAccordion = styled(Accordion)(() => ({
  background: 'transparent',
  boxShadow: 'none',
  '&::before': {
    display: 'none',
  },
}));

export const StyledAccordionSummaryTitle = styled('div')(() => ({
  fontWeight: 'bold',
  fontSize: 16,
}));

export const StyledOuterAccordionDetails = styled(AccordionDetails)(() => ({
  flexDirection: 'column' as const,
  padding: '0 0 8px',
}));

/** Inner accordion — one per question answer */
export const StyledInnerAccordion = styled(Accordion)(() => ({
  background: '#f5f5f5',
  boxShadow: 'none',
  marginBottom: 4,
  borderRadius: 6,
  marginLeft: 16,
}));

export const StyledAnswerLabel = styled(Typography)(() => ({
  fontWeight: 500,
  fontSize: 16,
}));

export const StyledGoHomeWrapper = styled('div')(() => ({
  marginTop: '24px',
  textAlign: 'center' as const,
}));

export const StyledUploadedImg = styled('img')(() => ({
  maxWidth: '100%',
  maxHeight: 300,
  borderRadius: 6,
  objectFit: 'contain' as const,
}));
